import React, { Component } from 'react';
import Link from 'gatsby-link';
import {observer, inject} from 'mobx-react';
import i18n from '../../i18n';
import {translate} from 'react-i18next';

import colors from '../../vars/colors';

import { Container, Row, Column } from '../global/grid/grid';
import { H1 } from '../global/typography/typography';

import DominosLogo from '../../static/svgs/dominos-logo.svg';
import P4PLogo from '../../static/svgs/p4p-logo.svg';

import CityMenu from './CityMenu';
import { HeaderWrapper, BackCarrot } from './styled-components';

@inject("store")
@observer class Header extends Component {
  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);
    this.gaCityDropdownOpened = this.gaCityDropdownOpened.bind(this);
  }
  onClick() {
    const { store } = this.props;
    store.toggleModal();
  }
  gaLogoClicked() {
    window.dataLayer.push({
      'event': 'logo:click',
      'nav': 'header',
      'navItem': 'dominos-logo'
    });
  }
  gaCityDropdownOpened() {
    const { store } = this.props;
    if(store.csMenu) {
      // console.log('gacitydropdownopened');
      window.dataLayer.push({
        'event': 'herocity-dropdown:open'
      });
    }
  }

  render() {
    const { store, data, t } = this.props;

    return (
      <HeaderWrapper csMenuOpen={store.csMenu}>
          <Container>
            <Row margins={false} style={{position: 'relative'}} alignItems={'center'}>
              <Column>
                  <div className="logoHolder">
                    <Link to="/" onClick={() => { if(store.csMenu) { store.csMenuToggle(); } this.gaLogoClicked(); }}>
                      <div style={{
                        display: 'inline-block',
                        transition: 'all 300ms ease-in-out',
                        transform: (store.csPage && store.isMobile) ? `translate3d(10px, 0, 0)` : `translate3d(0, 0, 0)`,
                        opacity: (store.csPage && store.isMobile) ? `1` : `0`,
                        pointerEvents: (store.csPage && store.isMobile) ? `all` : `none`,
                      }}>
                        <BackCarrot />
                      </div>
                      <div style={{
                        width: '30px',
                        display: 'inline-block',
                        transition: 'transform 300ms ease-in-out',
                        transform: (store.csPage && store.isMobile) ? `translate3d(20px, 0, 0)` : `translate3d(0, 0, 0)`,
                      }}>
                        <DominosLogo />
                      </div>
                      <div style={{
                        width: '70px',
                        marginLeft: '15px',
                        display: 'inline-block',
                        transition: 'all 300ms ease-in-out',
                        transform: (store.csPage && store.isMobile) ? `translate3d(20px, 0, 0)` : `translate3d(0, 0, 0)`,
                        opacity: (store.csPage && store.isMobile) ? `0` : `1`,
                        pointerEvents: (store.csPage && store.isMobile) ? `none` : `all`,
                      }}>
                        <P4PLogo />
                      </div>
                    </Link>
                  </div>
              </Column>
              { store.csPage && !store.isMobile &&
                <CityMenu data={data.pages} onClick={ this.gaCityDropdownOpened } />
              }
            </Row>
          </Container>
      </HeaderWrapper>
    )
  }
}

export default translate()(Header);



// WEBPACK FOOTER //
// ./src/components/header/header.js